// extracted by mini-css-extract-plugin
export default {"hideTooltip":"m9-z","fadeIn":"n9-z","delay":"o9-z","recommendedSizeTooltip":"p9-z"};